import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { IconSystemV2EssentialHome } from '@doltech/icons/SystemV2/IconSystemV2EssentialHome';
import { colorsV2 } from '../../colors-v2';
import { ResponsiveTypography } from '../../Typography/v3/ResponsiveTypography';
import { BreadcrumbItemArrow } from '../BreadcrumbItemArrow/BreadcrumbItemArrow';

const BreadcrumbItemIconLink = styled.a`
  display: flex;
  align-items: center;

  padding-right: 4px;
`;

const BreadcrumbItemTextLink = styled.a`
  padding: 2px 4px;
  cursor: pointer;
  user-select: none;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Container = styled.div`
  display: flex;
  align-items: center;

  .breadcrumb-item-text {
    border-bottom: 1px solid transparent;
  }

  &.active {
    .breadcrumb-item-text {
      cursor: default;
    }
  }

  &.primary {
    .breadcrumb-item-text {
      color: ${colorsV2.primary100};
    }
    .breadcrumb-item-icon {
      color: ${colorsV2.primary100};
    }

    &:hover {
      .breadcrumb-item-text {
        border-bottom-color: ${colorsV2.primary100};
      }
    }

    &.active {
      .breadcrumb-item-text {
        color: ${colorsV2.neutral100};
        border-bottom-color: transparent;
      }
      .breadcrumb-item-icon {
        color: ${colorsV2.neutral60};
      }
    }
  }

  &.blue {
    .breadcrumb-item-text {
      color: ${colorsV2.blue100};
    }
    .breadcrumb-item-icon {
      color: ${colorsV2.blue100};
    }

    &:hover {
      .breadcrumb-item-text {
        border-bottom-color: ${colorsV2.blue100};
      }
    }

    &.active {
      .breadcrumb-item-text {
        color: ${colorsV2.neutral100};
        border-bottom-color: transparent;
      }
      .breadcrumb-item-icon {
        color: ${colorsV2.neutral60};
      }
    }
  }

  &.black {
    .breadcrumb-item-text {
      color: ${colorsV2.neutral140};
    }
    .breadcrumb-item-icon {
      color: ${colorsV2.neutral120};
    }

    &:hover {
      .breadcrumb-item-text {
        border-bottom-color: ${colorsV2.neutral140};
      }
    }

    &.active {
      .breadcrumb-item-text {
        color: ${colorsV2.neutral100};
        border-bottom-color: transparent;
      }
      .breadcrumb-item-icon {
        color: ${colorsV2.neutral60};
      }
    }
  }

  &.purple {
    .breadcrumb-item-text {
      color: ${colorsV2.purple100};
    }
    .breadcrumb-item-icon {
      color: ${colorsV2.purple100};
    }

    &:hover {
      .breadcrumb-item-text {
        border-bottom-color: ${colorsV2.purple100};
      }
    }

    &.active {
      .breadcrumb-item-text {
        color: ${colorsV2.neutral100};
        border-bottom-color: transparent;
      }
      .breadcrumb-item-icon {
        color: ${colorsV2.neutral60};
      }
    }
  }
`;

interface BreadcrumbItemProps {
  type?: 'text' | 'home';
  actionType?: 'link' | 'click';
  colorStyle?: 'primary' | 'blue' | 'black' | 'purple';
  text?: string;
  href?: string;
  onClick?: () => void;
  active?: boolean;
}

export const BreadcrumbItem = (props: BreadcrumbItemProps) => {
  const { type = 'text', actionType = 'link', colorStyle = 'primary', text, href, onClick, active = false } = props;
  const link = actionType && href ? href : null;
  const handleClick = () => actionType === 'click' && onClick?.();

  switch (type) {
    case 'home':
      return (
        <Container className={cl('breadcrumb-item', type, colorStyle, { active })}>
          <BreadcrumbItemIconLink className="breadcrumb-item-icon" href={link} onClick={handleClick}>
            <IconSystemV2EssentialHome size={16} />
          </BreadcrumbItemIconLink>
        </Container>
      );
    case 'text':
    default:
  }

  return (
    <Container className={cl('breadcrumb-item', type, colorStyle, { active })}>
      <BreadcrumbItemArrow colorStyle={colorStyle} active={active} />
      <BreadcrumbItemTextLink className="breadcrumb-item-text" href={link} onClick={handleClick}>
        <ResponsiveTypography.Text variant="regular/14-20">
          {text}
        </ResponsiveTypography.Text>
      </BreadcrumbItemTextLink>
    </Container>
  );
};
